import {
	START_LOGIN,
	LOGIN_FAILURE,
	LOGIN_SUCCESS,
	RESET_ERROR,
	SIGN_OUT_SUCCESS
} from "./constants";

export const startLogin = () => ({
	type: START_LOGIN
});

export const loginSuccess = () => ({
	type: LOGIN_SUCCESS
});

export const loginFailure = () => ({
	type: LOGIN_FAILURE
});

export const resetError = () => ({
	type: RESET_ERROR
});

export const signin = (login, password) => dispatch => {
	dispatch(startLogin());

	if (Boolean(login) && Boolean(password)) {
		setTimeout(() => {
			localStorage.setItem("auth_token", login);
			// try {
			// 	const pathToFile = path.resolve(__dirname, "../../datas", `${login}-data.json`);
			// 	const rawdata = fs.readFileSync(pathToFile);
			// 	const data = JSON.parse(rawdata);
			// 	console.log(pathToFile, data);
			// } catch (err) {
			// 	throw new Error(err);
			// }
			dispatch(loginSuccess());
		}, 200);
	} else {
		dispatch(loginFailure());
	}
};

export const signoutSuccess = () => ({
	type: SIGN_OUT_SUCCESS
});

export const signout = () => dispatch => {
	localStorage.removeItem("auth_token");
	dispatch(signoutSuccess());
};
